module.exports = __webpack_public_path__ + "media/images/logo/fakturaonline-square-logo-de-f333e7f6ff62528c2cd0fbe9bb7f1eb8.svg";